import {Field} from "./Field";

export class CheckboxField extends Field<boolean> {
    stringValue = (): string | undefined => {
        if (this.value) {
            return "true";
        }
        return "false"
    };
}